"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEFAULT_ENTITIES = {
    'quot': '\u0022',
    'amp': '\u0026',
    'lt': '\u003C',
    'gt': '\u003E',
    'nbsp': '\u00A0',
};
/**
 * A small set of the most common entities for use during parsing.
 */
exports.default = DEFAULT_ENTITIES;
Object.freeze(DEFAULT_ENTITIES);
//# sourceMappingURL=default-entities.js.map